import axiosInstance from '../../../utils/axiosConfig'
import { mobileBackendUrl } from '../../../env'
import type { RegularPlanAlertVariant } from '../types'
import type { RegularPlanAlertSheetResponse } from '../types'

export async function fetchRegularPlanAlertSheet(
  bottomSheetType: RegularPlanAlertVariant
): Promise<{ data: RegularPlanAlertSheetResponse }> {
  const params = new URLSearchParams({ bottomSheetType })
  return axiosInstance.get<RegularPlanAlertSheetResponse>(
    `${mobileBackendUrl}/v2/portfolio/app-startup-web-bottom-sheet?${params.toString()}`
  )
}
